var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import TimePickerComponent from '@wojtekmaj/react-timerange-picker';
import styled from 'styled-components';
import Label from '../Label/Label';
import Error from '../Error/Error';
const PickerStyle = styled.div `
  display: inline-block;
  margin: ${props => props.theme.paddingsMargins.themeMenuMargin};
  & .react-timerange-picker__wrapper {
    padding: ${props => props.theme.paddingsMargins.inputsPadding};
    border-radius: ${props => props.theme.borders.borderRadius};
    border: ${props => props.theme.utils.borderColor(props.theme.utils.getColor('grey'))};
    &:hover {
      border: ${props => props.theme.utils.customBorders(props.color)};
    }
  }
  & div {
    color: ${props => props.theme.utils.getColor(props.color)};
  }
  & select {
    -webkit-appearance: none;
    -moz-appearance: none;
    color: ${props => props.theme.utils.getColor(props.color)};
    &::-ms-expand {
      display: none;
    }
  }
  & svg {
    stroke: ${props => props.theme.utils.getColor(props.color)};
  }
  & input {
    color: ${props => props.theme.colors.darkColor};
  }
  &
    .react-timerange-picker__button:enabled:hover
    .react-timerange-picker__button__icon,
  .react-timerange-picker__button:enabled:focus
    .react-timerange-picker__button__icon {
    stroke: ${props => props.theme.utils.getColorLight(props.color)};
  }
`;
const TimePicker = (_a) => {
    var { value, onChange, required, label, labelSize = 'article', register, errors = {}, name, color = 'main', labelColor } = _a, props = __rest(_a, ["value", "onChange", "required", "label", "labelSize", "register", "errors", "name", "color", "labelColor"]);
    return (_jsxs(PickerStyle, Object.assign({ color: color }, props, { children: [!!label && (_jsx(Label, { label: label, labelSize: labelSize, color: labelColor || color })), _jsx(TimePickerComponent, { ref: register, required: required, locale: "en-US", disableClock: true, minutePlaceholder: "mm", hourPlaceholder: "hh", onChange: onChange, value: value, className: "date-picker" }), !!errors[name] && _jsx(Error, { children: errors[name].message })] })));
};
export default TimePicker;
